'use strict';

import Cookies from 'js-cookie';
import { loadJS } from './asset-loaders';
import InterNACHI from 'shared/InterNACHI.js';

const SESSION_SCRIPT_PATTERN = /^\/dynamic\/js\/session\/\d+\/(?:0|[0-9a-f]{40})\.js$/;

const cookie = Cookies.get('__Host-session-js');
const session = SESSION_SCRIPT_PATTERN.test(cookie) ? cookie : null;

if (session) {
	loadJS(session, { async: false, defer: false });
} else {
	loadJS('/dynamic/js/session/0/0.js', { async: false, defer: false });
}

InterNACHI.session.onLoaded(() => {
	try {
		localStorage.setItem('internachi_session', JSON.stringify({
			session_js: session,
			logged_in_user: window.logged_in_user,
		}));
	} catch (e) {
		console.error(e);
	}
});

InterNACHI.session.onGuest(() => {
	try {
		localStorage.setItem('internachi_session', JSON.stringify({
			session_js: null,
			logged_in_user: null,
		}));
	} catch (e) {
		console.error(e);
	}
});
